import React from 'react';
import { TypedMemo } from '../../../common/types';
import type { OutreachProfileDto } from '../outreachTypes';
import type { ProfileUpdate } from '../hooks/useProfileActions';
import { ProfileTagsCard } from './ProfileTagsCard';
import { ProfileSimilarCard } from './ProfileSimilarCard';
import { ProfileMarketsCard } from './ProfileMarketsCard';
import { ProfileSizeCard } from './ProfileSizeCard';
import { ProfileStoryCard } from './ProfileStoryCard';
import { ProfileSenderCard } from './ProfileSenderCard';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for Outreach; each part uses its own slice of it */
import styles from '../Outreach.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface ProfileGridProps {
  profile: OutreachProfileDto;
  onSave: (patch: ProfileUpdate) => void;
  disabled: boolean;
}

/** The two columns of Your sound (design outreach b1). */
const ProfileGridComponent: React.FC<ProfileGridProps> = ({ profile, onSave, disabled }) => (
  <div className={styles.grid2}>
    <div className={styles.stack}>
      <ProfileTagsCard profile={profile} onSave={onSave} disabled={disabled} />
      <ProfileSimilarCard profile={profile} onSave={onSave} disabled={disabled} />
      <ProfileSenderCard profile={profile} onSave={onSave} disabled={disabled} />
    </div>
    <div className={styles.stack}>
      <ProfileMarketsCard markets={profile.markets} onSave={onSave} disabled={disabled} />
      <ProfileSizeCard tier={profile.careerTier} />
      <ProfileStoryCard profile={profile} onSave={onSave} disabled={disabled} />
    </div>
  </div>
);

export const ProfileGrid = TypedMemo(ProfileGridComponent);
